import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { doesTooltipNotHaveOwnerToDisplay } from '../Tooltips/Elements/Tooltip';
import { LensTooltip } from '../Tooltips/LensTooltip';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { LensThumbnail } from './LensThumbnail';

export class LensCard extends ContentCard {

  public render() {
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          delay={0}
          title={Messages.lensTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <LensThumbnail
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
            owner={this.props.content.owner}
            urls={this.props.urls}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName}>
            {this.props.content.name}
          </span>

          {FeatureFlags.askDataLensFavoritingEnabled && this.showFavoritesStar() && <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'lens' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'lens' })}
            />
          </span>}
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderTooltipContent = () => {
    return <LensTooltip
      content={this.props.content}
      urls={this.props.urls} />;
  }
}
